import React, {useState} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {toast} from 'react-toastify';
import {formatErrors, validateEmail} from '../../constants';
import {restoreAction} from '../../actions/loginAction';
import {InputLogin} from "../../utils/input/InputLogin";

function Restore(props) {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, handleChange] = useState({
    email: ''
  });

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    handleChange({...form, [name]: value});
    setErrors({...errors, [name]: value.trim() === ''});
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.email === '' || validateEmail(form.email) !== true) {
      errs.email = true;
    }
    setErrors(errs);

    if (Object.keys(errs).length > 0) {
      return false;
    }
    setLoading(true);

    props.restore(form).then(() => {
      setLoading(false);
      handleChange({email: ''});
      toast.success('Письмо отправлено', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch(err => {
      setLoading(false);
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      if (err.message === 'wrong:email') {
        setErrors({email: true});
      }
    });
  }

  return <div className="auth">
    <form noValidate className="auth__wrapper" onSubmit={handleSubmit}>
       <div className="auth__top">
         <div className="auth__icon" style={{backgroundImage: "url(/img/logo-outline.svg)"}}></div>
         <h3 className="auth__title">Забыли пароль?</h3>
       </div>

       <div className="auth__inner">
         <InputLogin type="email"
                     name="email"
                     placeholder="Введите почту"
                     title="Email адрес"
                     value={form.email}
                     error={errors.email || false}
                     onChange={handleChangeForm}/>

         <div className="auth__group">
           <p className="auth__help">Инструкции по сбросу пароля будут высланы на указанный адрес электронной почты.</p>
         </div>
       </div>
       <div className="auth__buttons">
         <Link to="/login" className="auth__btn auth__btn--canceling btn">Отмена</Link>
         <button type="submit" className="auth__btn btn" disabled={loading}>Отправить</button>
       </div>
    </form>
  </div>;
}

const mapDispatchToProps = (dispatch) => {
  return {
    restore(data) {
      return dispatch(restoreAction(data));
    }
  }
};

export default connect(null, mapDispatchToProps)(withRouter(Restore))
